import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './CarType.module.css'
import styleNames from '../../utils/styleNames'
import FormActions from '../../actions/FormActions'
import { formatFixedPrice } from '../../utils/format'
import classNames from 'classnames'

export class CarType extends Component {
  _radioButtonPressed (carType) {
    FormActions.selectCarType(carType.name)
  }

  _getImageForCarType (name) {
    switch (name) {
      case 'taxi':
        return 'icon-taxi-standard@3x'
      case 'storbil':
        return 'icon-taxi-large@3x'
      case 'business':
        return 'icon-taxi-premium@3x'
    }
  }

  _renderExtraInfo (carTypes) {    
    let extraInfo = '\u00A0'
    carTypes.forEach(function(carType) { 
      if (carType.checked && carType.extraInfo) extraInfo = 'Info: ' + carType.extraInfo
    })
    return extraInfo
  }

  _renderCarType (carType, i) {
    const { fixedPrice, taxiIsDisabled, premiumIsDisabled } = this.props
    const { name } = carType
    const labelStyles = classNames('labels', {
      estimate: fixedPrice && (carType.estimate || carType.estimateNotAvailable === true)
    })

    return (
      <li
        key={`CarType_${i}`}
        onClick={() => this._radioButtonPressed(carType)}
        className={styleNames(styles, classNames('radio-button', {
          active: carType.checked,
          disabled: (name === 'taxi' && taxiIsDisabled) || (name === 'business' && premiumIsDisabled)
        }))}>
        <input
          checked={carType.checked}
          name="carType"
          onFocus={() => this._radioButtonPressed(carType)}
          readOnly
          type="radio" />
        <div className={styles.indicator}>
          <img src={`/static/img/cars/${this._getImageForCarType(name)}.png`} />
          <div className={styleNames(styles, labelStyles)}>
            <label className={styles.label}>{carType.label}</label>
            <small className={styles.labelSmall}>{carType.labelSmall}</small>
            { fixedPrice && carType.estimate && <label className={styles.label}>{formatFixedPrice(carType.estimate)}</label> }
            { fixedPrice && carType.estimate && <small className={styles.labelSmall}> Fast pris</small> }
            { fixedPrice && carType.estimateNotAvailable && <small className={styles.labelSmall}>Fast pris <strong>ej tillgängligt</strong></small> }
          </div>
        </div>
      </li>
    )
  }

  render () {
    const { carTypes, fixedPrice } = this.props
    const extraInfo = fixedPrice ? 'Info: Eventuell väntetidskostnad tillkommer på det fasta priset' : this._renderExtraInfo(carTypes)
    return (
      <div className={styles['carType-container']}>
        <h2>Biltyp</h2>
        <ul className={styles.radiobuttons}>
          {carTypes.map((carType, i) => this._renderCarType(carType, i))}
        </ul>
        <p dangerouslySetInnerHTML={{ __html: extraInfo }} className={styles['carType-info']}/>
      </div>
    )
  }
}

CarType.propTypes = {
  carTypes: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string,
    labelSmall: PropTypes.string,
    extraInfo: PropTypes.string,
    checked: PropTypes.bool,
    estimate: PropTypes.shape({}),
    estimateNotAvailable: PropTypes.bool
  })),
  fixedPrice: PropTypes.bool,
  premiumIsDisabled: PropTypes.bool,
  taxiIsDisabled: PropTypes.bool
}

CarType.defaultProps = {
  carTypes: []
}

export default CarType
